import injectSheet from 'react-jss'
import Modal from './Modal'
import styles from './Modal.styles'

export default injectSheet(styles)(Modal)
